/**
 * Builds the active search result sections from raw results.
 *
 * Non-product items (franchises, characters, collections, creators)
 * are merged into a single "results" section sorted by relevance score.
 * Products remain in their own section with original order preserved.
 */
export default function buildActiveSections(results) {
  const creators = results.influencers.filter(
    (item) => !item.payload.isCollection,
  );
  const collections = results.influencers.filter(
    (item) => item.payload.isCollection,
  );

  const unified = [
    ...results.franchises,
    ...results.characters,
    ...collections,
    ...creators,
  ].toSorted((a, b) => (b.score ?? 0) - (a.score ?? 0));

  const sections = [];

  if (unified.length > 0) {
    sections.push(["results", unified]);
  }

  if (results.products.length > 0) {
    sections.push(["products", results.products]);
  }

  return sections;
}
